import { Box, Grid, Skeleton, Typography, useTheme } from "@mui/material";

export default function InfoCard({
    icon,
    label,
    value,
    isLoading
}: {
    icon: JSX.Element;
    label: string;
    value: string | number;
    isLoading: boolean;
}): JSX.Element {
    const theme = useTheme()

    return (
        <Grid
            item
            xs={12}
            sm={6}
            lg={2.4}
        >
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                padding: {
                    xs: '20px 12px',
                    sm: '14px 14px',
                    md: '16px 16px',
                    lg: '18px 16px',
                    xl: '20px 16px'
                },
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                borderRadius: '15px',
                backgroundColor: theme.palette.common.white,
                columnGap: "10px"
            }}>
                <Box
                    sx={{
                        flexShrink: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    {isLoading && <Skeleton variant="rounded" width={57} height={57} />}
                    {!isLoading && icon}
                </Box>
                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        rowGap: "4px"
                    }}
                >
                    {isLoading && (
                        <>
                            <Skeleton
                                variant="text"
                                sx={{
                                    width: "50%",
                                    ...theme.typography.subtitle_500
                                }}
                            />
                            <Skeleton
                                variant="text"
                                sx={{
                                    width: "75%",
                                    ...theme.typography.body_700
                                }}
                            />
                        </>
                    )}
                    {!isLoading && (
                        <>
                            <Typography variant='subtitle_500'>{label}</Typography>
                            <Typography variant='body_700' sx={{ wordBreak: "break-all" }}>
                                {value}
                            </Typography>
                        </>
                    )}
                </Box>
            </Box>
        </Grid>
    )
}